/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1027
 */

"use strict"

export { i as a }
import * as /* [auto-meaningful-name] */Module_391 from /* 391 */"../../../../551/1211/269/391"
function i(e) {
  return Module_391.a(e).defaultView || window
}
export default i
